export const DEFAULT_IMAGE_PREVIEW_SIZE = 240;
export const IMAGE_PREVIEW_THUMB_RADIUS = 12;
export const IMAGE_PREVIEW_FALLBACK_ALT_LABEL = "image unavailable";
export const IMAGE_PREVIEW_FALLBACK_GAP = 6;
export const IMAGE_PREVIEW_FALLBACK_PADDING = 10;
export const IMAGE_PREVIEW_FALLBACK_ICON_SIZE = 28;
export const IMAGE_PREVIEW_FALLBACK_ICON_OPACITY = 0.45;
export const IMAGE_PREVIEW_FALLBACK_TEXT_SIZE = 12;
export const IMAGE_PREVIEW_FALLBACK_TEXT_OPACITY = 0.6;
export const IMAGE_PREVIEW_REFERRER_POLICY = "no-referrer";
export const IMAGE_PREVIEW_LIGHTBOX_MAX_HEIGHT = "90vh";
export const IMAGE_PREVIEW_HOVER_ANIMATION = {
  scale: 1.02,
  filter: "brightness(1.05)",
} as const;
export const IMAGE_PREVIEW_TAP_ANIMATION = { scale: 0.97 } as const;
export const IMAGE_PREVIEW_HOVER_TRANSITION = {
  duration: 0.15,
  ease: [0.4, 0, 0.2, 1] as const,
};
/** Blurred, over-scaled copy of the image that fills the box behind a contained
 *  fit, so an off-ratio image reads as one composed plate instead of a crop. */
export const IMAGE_PREVIEW_BLOOM_BACKDROP_STYLE = {
  position: "absolute",
  inset: 0,
  display: "block",
  transform: "scale(1.25)",
  filter: "blur(28px) saturate(140%) brightness(0.7)",
  pointerEvents: "none",
} as const;
